// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"fbe98cee3576177b8d02","655":"1d8de2f1a6ab355da2fd"}[chunkId] + ".js";
};